import { render, staticRenderFns } from "./ItemDetectionFileComponent.vue?vue&type=template&id=6daeae84&scoped=true&"
import script from "./ItemDetectionFileComponent.vue?vue&type=script&lang=js&"
export * from "./ItemDetectionFileComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daeae84",
  null
  
)

export default component.exports